import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import {RestapiService} from '../restapi.service';


@Component({
  selector: 'app-change-psw',
  templateUrl: './change-psw.component.html',
  styleUrls: ['./change-psw.component.css']
})
export class ChangePswComponent implements OnInit {

  constructor(private router: Router,private route: ActivatedRoute, private _rest: RestapiService) { }
	oldPassword="";
	confirmPassword="";
	newPassword="";
	userType = "";
	respObject: any;
	userId: any;
	companyId: any;
  	ngOnInit(){
  		this.userType = localStorage.getItem('userRole');
  		this.userId = localStorage.getItem('userId');
  		this.companyId = localStorage.getItem('companyId');
  	}
  	changePassword(){
  		var errCounter = 0;
  		if(this.oldPassword==""){
  			errCounter++;
  		}
  		if(this.confirmPassword==""){
  			errCounter++;
  		}
  		if(this.newPassword==""){
  			errCounter++;
  		}
  		if(errCounter>0){
  			alert("All Fields are required.");
  		} else {
  			if(this.newPassword!=this.confirmPassword){
  				alert("Please re-enter password correctly.");
  				errCounter++;
  			} else {
  				if(this.newPassword==this.oldPassword){
  				 alert("Old Password and New Password should be different.");
  				} else {
  					var uRole = 0;
  					if(this.userType=="admin"){
  						uRole 	= 1;
  					} else if(this.userType=="analyst"){
  						uRole 	= 2;
  					} else if(this.userType=="ceo"){
  						uRole 	= 3;
  					}
  					const data = {
  						"userId":this.userId,
  						"userRole":uRole,
  						"companyId":this.companyId,
  						"oldPassword":this.oldPassword,
  						"newPassword":this.newPassword
  					};
  					this._rest.changePassword(data).subscribe((res) => {
  						this.respObject = res;
  						if(this.respObject.error==0){
							alert("Password has been changed successfully.");
	  						window.location.reload();
						} else {
							alert(this.respObject.errorMessage);
						}
  					});
  				}
  			}
  		}
  	}

}
